import dynamic from 'next/dynamic';
import css from './index.module.scss';
import BannerModule from '@/components/ProductDetailComponents/BannerModule';
import { useGlobal } from '@/utils/useGlobal';

const Content = dynamic(() => import('./dynamicContent'), {
    ssr: true,
});

export default function SolarPanel() {
    const { useLang } = useGlobal();
    const { t } = useLang('100wflexiblesolarpanel');

    const bannerData = [
        {
            bgImgs: ['01.webp', '01.jpg'],
            title: t('solarpanels_100w_flexible.title'),
            des: t('solarpanels_100w_flexible.des'),
        },
    ];

    const webpUrl = '/media/100W_flexible/pc/';

    return (
        <div className={`${css.animationWrapper} solarPanelModule`}>
            <div style={{ width: '100%', marginTop: '-64px' }}>
                <BannerModule data={bannerData} config={{ isShowLogo: false, webpUrl }} />
            </div>
            <Content />
        </div>
    );
}
